import { ThemeOption } from '@helpers/brand';
import { formatDate, formatDateISO } from '@helpers/date';
import { imageUrl } from '@helpers/image';
import SvgDocuments from '@img/icons/documents.svg';
import { ButtonType } from '@stories/Components/Buttons/Button/ButtonType';
import FakeButton from '@stories/Components/Buttons/FakeButton/FakeButton';
import * as React from 'react';
import S from './ArticleCard.styles';
const ArticleCard = (props) => {
    return (React.createElement(S.Container, { "data-theme": props.theme ? props.theme : ThemeOption.Default },
        React.createElement(S.Link, { href: props.url },
            React.createElement(S.ImageWrapper, null, props.image && (React.createElement(S.Image, { alt: props.image.altText, loading: props.order === 0 ? 'eager' : "lazy", role: props.image.altText ? undefined : 'presentation', sizes: "100vw", src: imageUrl(props.image, { width: 264, heightratio: 280 / 480 }), srcSet: [
                    `${imageUrl(props.image, { width: 222, heightratio: 280 / 480 })} 320w`,
                    `${imageUrl(props.image, { width: 344, heightratio: 280 / 480 })} 480w`,
                    `${imageUrl(props.image, { width: 480, heightratio: 280 / 480 })} 767w`,
                ].join(','), width: "480", height: "280" }))),
            React.createElement(S.ContentWrapper, null,
                React.createElement(S.Metadata, null,
                    "Posted on:",
                    ' ',
                    React.createElement(S.Date, { dateTime: formatDateISO(props.date) }, formatDate(props.date))),
                React.createElement(S.Title, null, props.title),
                React.createElement(S.Content, null, props.content),
                React.createElement(S.CtaWrapper, null,
                    React.createElement(FakeButton, { buttonType: ButtonType.Outline, icon: React.createElement(SvgDocuments, null) }, "Read More"))))));
};
export default ArticleCard;
